import { useIntl } from 'react-intl';
import { Route, Routes } from 'react-router-dom';

import { useSelector } from '_common/hooks';
import { navigateToMyFiles } from 'router/navigation';

import { selectUserIsAdmin } from '_common/services/api/authority';
import { DocumentTitle, ErrorView, IntlErrorBoundary, Sidebar } from '_common/components';

import StoragePage from './pages/StoragePage/StoragePage';
import RecyclePage from './pages/RecyclePage/RecyclePage';
import SpacesListPage from './pages/SpacesListPage/SpacesListPage';
import PersonalSpacesListPage from './pages/PersonalSpacesListPage/PersonalSpacesListPage';

import styles from './StorageContainer.module.scss';

const StorageContainer = () => {
  const intl = useIntl();

  const listingPersonalSpaces = useSelector((state) => state.spaces.personals);
  const userIsAdmin = useSelector(selectUserIsAdmin);

  return (
    <div className={styles.root}>
      <Sidebar />
      <Routes>
        <Route
          index
          element={
            <DocumentTitle
              title={`doDOC - ${intl.formatMessage({
                id: 'storage.sidebar.myFiles',
              })}`}
            >
              <IntlErrorBoundary size="xl" style={{ margin: '21rem auto 0 auto' }}>
                <StoragePage />
              </IntlErrorBoundary>
            </DocumentTitle>
          }
        />
        <Route
          path="recycle"
          element={
            <DocumentTitle
              title={`doDOC - ${intl.formatMessage({
                id: 'global.recycle',
              })}`}
            >
              <IntlErrorBoundary size="xl" style={{ margin: '21rem auto 0 auto' }}>
                <RecyclePage />
              </IntlErrorBoundary>
            </DocumentTitle>
          }
        />
        <Route
          path="spaces"
          element={
            <DocumentTitle
              title={`doDOC - ${intl.formatMessage({
                id: 'storage.sidebar.spaces',
              })}`}
            >
              <IntlErrorBoundary size="xl" style={{ margin: '21rem auto 0 auto' }}>
                {userIsAdmin && listingPersonalSpaces ? (
                  <PersonalSpacesListPage />
                ) : (
                  <SpacesListPage />
                )}
              </IntlErrorBoundary>
            </DocumentTitle>
          }
        />
        <Route
          path=":type/:id"
          element={
            <IntlErrorBoundary size="xl" style={{ margin: '21rem auto 0 auto' }}>
              <StoragePage />
            </IntlErrorBoundary>
          }
        />
        <Route
          path="*"
          element={
            <ErrorView
              error={{
                status: 404,
              }}
              onClick={navigateToMyFiles}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default StorageContainer;
